import apiAuthenticate from "../../config/apiAuthenticate";
import { CLIENT_KEY } from "../../config/config";
import { objToQueryString, showSuccessToasts } from "../../services/helpers/Helper";
import { END_POINT, USER_TYPE } from "../constants";
import { setError } from "./errorAction";
import { hideLoading, showLoading } from "./loadingAction";

export const loginUser = (ticket, navigate) =>
   async (dispatch) => {
      const params = {
         ticket,
         clientKey: CLIENT_KEY
      }
      dispatch(showLoading());
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.LOGIN_TICKET}?${qs}`;
      apiAuthenticate.post(endPoint).then((response) => {
         dispatch({
            type: USER_TYPE.LOGIN,
            payload: response.data
         });
         showSuccessToasts("Đăng nhập thành công");
         navigate('/');
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   };

export const logoutUser = () =>
   async (dispatch, getState) => {
      const { user } = getState();
      const params = {
         clientKey: CLIENT_KEY,
         accessToken: user.accessToken
      }
      dispatch(showLoading());
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.LOGOUT_TICKET}?${qs}`;
      apiAuthenticate.post(endPoint).then(() => {
         dispatch({
            type: USER_TYPE.LOGOUT,
            payload: {}
         });
         showSuccessToasts("Đăng xuất thành công");
         setTimeout(() => {
            window.location.reload();
         }, 1000);
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   };